import * as React from 'react';

import { singleton } from 'logic/singleton';
import type { LogViewMessage } from 'logview/types';

export type ActiveMessageDetailsState = {
  frontendId: LogViewMessage['message']['frontendId'];
  glIndex: LogViewMessage['index'];
} | null;
export type ActiveMessageDetailsStateSetter = React.Dispatch<React.SetStateAction<ActiveMessageDetailsState>>;

export interface MessageDetailsContextValue {
  activeMessageDetails: LogViewMessage;
  setActiveMessageDetailsState: ActiveMessageDetailsStateSetter;
  selectNextMessage: () => void | undefined;
  selectPrevMessage: () => void | undefined;
}

const MessageDetailsContext = React.createContext<MessageDetailsContextValue | undefined>(undefined);

export default singleton('contexts.enterprise.LogViewMessageDetailsContext', () => MessageDetailsContext);
